module.exports = __webpack_public_path__ + "img/aiimg9.8f199a1c.png";